import getInvoice from 'services/api/invoice/getInvoice';
import submitInvoicePayment from 'services/api/invoice/submitInvoicePayment';

export default {
    getInvoice,
    submitInvoicePayment
};
